import { Route } from 'react-router-dom';
import { FC } from 'react';

import { AccountLayout } from 'components/account/AccountLayout';
import { AccountSettingsContainer } from 'components/account/account-settings';
import { privateRoutes } from './routesConstants';

type Props = {
};

export const SettingsRoutes: FC<Props> = () => (
  <Route
    path={privateRoutes.loginAs}
    element={<AccountLayout />}
  >
    <Route
      path=""
      element={<AccountSettingsContainer />}
    />
  </Route>
);

export default SettingsRoutes;
